import { render, staticRenderFns } from "./RecentNotificationIndex.vue?vue&type=template&id=63dfe73e&scoped=true&"
import script from "./RecentNotificationIndex.vue?vue&type=script&lang=js&"
export * from "./RecentNotificationIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dfe73e",
  null
  
)

export default component.exports